var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "fade" } },
    [
      _vm.showModal
        ? _c("Modal", { on: { close: _vm.closeModal } }, [_vm._t("default")], 2)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }